import {lazy} from '@aboutyou/lazy-imports';
import {
  COLORS,
  Drawer,
  GenericIconName,
  HeaderButton,
} from '@aboutyou/ui-components';
import React, {memo} from 'react';
import {useSelectedDiscountColor} from '../../../../backend-services/Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {useWalletStateManager} from '../../../../backend-services/Wallet/utils/useWalletStateManager';
import {useGetCouponsCount} from '../hooks/useGetCouponsCount';
import {useIsCouponWalletActive} from '../hooks/useIsCouponWalletActive';
import {useShowNewCouponsNotificationBadge} from '../hooks/useShowNewCouponsNotificationBadge';
import {useTrackCouponWalletEntryPoint} from '../hooks/useTrackCouponWalletEntryPoint';

const Wallet = lazy(() =>
  import('../../../../backend-services/Wallet/Wallet').then(mod => ({
    default: mod.Wallet,
  })),
);
const MemoWallet = memo(Wallet);

const CouponWalletAddToBasket = lazy(() =>
  import('../CouponWalletAddToBasket/CouponWalletAddToBasket').then(mod => ({
    default: mod.CouponWalletAddToBasket,
  })),
);
const MemoCouponWalletAddToBasket = memo(CouponWalletAddToBasket);

export const HeaderCouponWalletButton = () => {
  const isCouponWalletActive = useIsCouponWalletActive();
  const couponsCount = useGetCouponsCount();
  const selectedDiscountColor = useSelectedDiscountColor();
  const {open} = useWalletStateManager();
  const {featureImpressionRef, trackFeatureClick} =
    useTrackCouponWalletEntryPoint();
  const {showNewCouponsNotificationBadge, setCouponWalletWasOpened} =
    useShowNewCouponsNotificationBadge(couponsCount);

  if (!isCouponWalletActive) {
    return null;
  }

  const handleOnClick = () => {
    trackFeatureClick();
    open('coupons');
    setCouponWalletWasOpened();
  };

  return (
    <>
      <HeaderButton
        data-testid="HeaderCouponWalletButton"
        asset={GenericIconName.Coupon}
        iconSize="S"
        badgeColor={selectedDiscountColor || COLORS.RedSale}
        count={showNewCouponsNotificationBadge ? couponsCount : 0}
        badgeOffset={{
          right: 0,
          top: 2,
        }}
        showBadge={showNewCouponsNotificationBadge}
        onClick={handleOnClick}
        ref={featureImpressionRef}
      />
      <MemoWallet ContentPopperLayoutComponent={Drawer} />
      <MemoCouponWalletAddToBasket renderMiniADP />
    </>
  );
};
